/**
 * GenerateText skill catalog — client cache backed by FunctionNodeSkillBinding.
 * Never hardcode fashion skill names in the Select.
 */

import { listTextGenerationSkills, type TextGenerationSkillDescriptor } from '../../../api'
import { singleFlightCached } from './canvasRequestDedup'
import {
  normalizeTextGenerationSkillDescriptor,
  type GenerateTextSkillLike,
} from './generateTextSkillFilter'

export type { GenerateTextSkillLike } from './generateTextSkillFilter'
export {
  filterImageCompatibleTextSkills,
  findTextGenerationSkill,
  resolveGenerateTextSkill,
  skillAcceptsImageInput,
  normalizeAcceptedInputType,
  normalizeTextGenerationSkillDescriptor,
} from './generateTextSkillFilter'

const SKILLS_TTL_MS = 60_000

function normalizeSkillList(raw: TextGenerationSkillDescriptor[] | GenerateTextSkillLike[]): GenerateTextSkillLike[] {
  const out: GenerateTextSkillLike[] = []
  for (const item of raw) {
    const normalized = normalizeTextGenerationSkillDescriptor(item as unknown as Record<string, unknown>)
    if (normalized) out.push(normalized)
  }
  return out
}

export function loadTextGenerationSkillsDeduped(
  workspaceId: string,
  locale?: string,
): Promise<GenerateTextSkillLike[]> {
  const localeKey = locale || ''
  const key = `textGenerationSkills:${workspaceId}:${localeKey}`
  return singleFlightCached(
    key,
    async () => {
      const res = await listTextGenerationSkills(workspaceId, locale)
      return normalizeSkillList(Array.isArray(res.skills) ? res.skills : [])
    },
    SKILLS_TTL_MS,
  )
}
